export default "__VITE_ASSET__BxNnEeLx__"